module.exports = __webpack_public_path__ + "0469671ad1d8491193dce0c7cf0e873a.svg";